import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  Add,
  Button,
  CardComponent,
  Group,
  PageTitleAndSubTitle,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { financialForensicsConstants } from '../../core-utils/messages/financialForensicsConstants';
import Typography from '@HomaHealth/ui-component-library/lib/_patient-access-components/atoms/Typography';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import TabSelection from '../../_components/molecules/TabSelection';
import { observer } from 'mobx-react';
import {
  calculateFee,
  fiscalControlDocumentsColumns,
  formatDocuments,
  formatReconcilation,
  getFixedCostColumns,
  getRowTypeFixedCost,
  getVariableCostColumns,
  transformStoplossToVendors,
  UnitType,
} from '../../core-utils/helper-utils/financialForensicsHelper';
import axios, { AxiosError } from 'axios';
import properties from '../../core-utils/properties';
import { useStores } from '../../stores';
import Loader from '../../_components/molecules/Loader';
import {
  addVendor as addVendorAPI,
  addClaims as addClaimsAPI,
  updateClaims as updateClaimsAPI,
  addRebates as addRebatesAPI,
  updateVendor as updateVendorAPI,
  deleteVendor as deleteVendorAPI,
  deleteClaim as deleteClaimsAPI,
  deleteRebates as deleteRebatesAPI,
  updateFeeCalculationVendor as updateFeeCalculationVendorAPI,
  updateRebates as updateRebatesAPI,
  getAvailableDates as getAvailableDatesAPI,
  addPlanDates as addPlanDatesAPI,
  uploadFiscalControlFiles,
  deleteFiscalControlFile,
  addStopLossVendor as addStopLossVendorAPI,
  updateStoplossVendor as updateStoplossVendorAPI,
  updateFeeCalculationStoploss as updateFeeCalculationStoplossAPI,
} from '../../core-utils/axios/financials/financial';
import useSnackbar from '../../core-utils/custom-hooks/Snackbar';
import Snackbar from '../../_components/atoms/Snackbar';
import FeeCalculationModal from '../../_components/organisms/FeeCalculationModal';
import AddReimbursementModal from '../../_components/organisms/AddReimbursementModal';
import Financials from '../../_components/organisms/FinancialsTab';
import EmployeeCountTab from '../../_components/organisms/EmployeeCountTab';
import AddEmployeeCountModal from '../../_components/organisms/AddEmployeeCountModal';
import {
  FeeCalculationModalType,
  getEmptyFeeCalculationModalState,
  getEmptyOtherClaimsModalState,
  getEmptyReimbursementModalState,
  getEmptyVendorModalState,
  OtherClaimsModalType,
  ReimbursementModalType,
  RowType,
  VendorModalType,
} from './FinancialForensics.types';
import AddVendorModal from '../../_components/organisms/AddVendorModal';
import AddOtherClaimLineModal from '../../_components/organisms/AddOtherClaimLineModal';
import AddStoplossModal from '../../_components/organisms/AddStoplossModal';
import { useNavigate } from 'react-router-dom';
import {
  addScenarios,
  saveBuildScenario,
} from '../../core-utils/axios/financials/scenarios';
import {
  RECONCILIATION_WORKSPACE,
  SCENARIO_WORKSPACE,
} from '../../core-utils/routes';
import AddBuildScenarioModal from '../../_components/organisms/AddBuildScenarioModal';
import CustomDateSelectionDropdown, {
  DateType,
} from '../../_components/molecules/CustomDateSelectionDropdown';
import BasicModal from '../../_components/atoms/BasicModal';
import CustomDateSelection from '../../_components/molecules/CustomDateSelection';
import {
  resetFeesToZero,
  resetVariableCostValuesToZero,
} from '../../core-utils/helper-utils/buildScenarioHelper';
import {
  addBuildReconciliation,
  addReconciliation,
  fetchReconciliations,
} from '../../core-utils/axios/financials/reconciliations';
import { getPreviousYearDates } from '../../core-utils/helper-utils/helper';
import ReconciliationModal, {
  Reconcilation,
  ReconcilationInfo,
} from '../../_components/organisms/ReconciliationModal';
import {
  EmployeeCount,
  EmployeeCountModalProps,
  emptyEmployeeCountModalData,
  FormatType,
  getEmptyEmployeeCount,
} from './types/EmployeeCount.types';
import {
  formatEmployeeCountModalData,
  formatUpdatedEmployeeCount,
} from '../../core-utils/helper-utils/financialForensics/employeeCountHelper';
import {
  emptyVendorEntry,
  getEmptyVariableCost,
  VariableCost,
  VendorEntry,
} from './types/VariableCost.types';
import {
  Document,
  emptyFixedCostFeeCalculation,
  emptyVendor,
  FixedCost,
  FixedCostFeeCalculation,
  getEmptyFixedCost,
  Service,
  Vendor,
} from './types/FixedCost.types';
import {
  calculateSum,
  getCalculationVariables,
} from '../../core-utils/helper-utils/financialForensics/fixedCostHelper';
import FiscalControlDocumentsTab from '../../_components/organisms/FiscalControlDocumentsTab';
import {
  DocumentDetailsForModal,
  emptyDocumentDetailsForModal,
} from '../ReconciliationWorkspace/ReconciliationWorkspace.types';
import useDocumentUpload from '../../core-utils/custom-hooks/DocumentUpload';
import DocumentViewModal from '../../_components/molecules/DocumentViewModal';
import DocumentUploadModal from '../../_components/organisms/DocumentUploadModal';
import { createBlobUrl } from '../../core-utils/helper-utils/contractAIQHelper';
import { useWebSocket } from '../../core-utils/custom-hooks/WebSocket';
import {
  emptyStoplossVendor,
  StoplossCoverage,
  StopLossVendor,
  SubscriptionData,
} from './types/StopLoss.types';
import {
  checkUserAccess,
  UserAccessConstants,
} from '../../core-utils/helper-utils/userAccess';
import CohortDetailsModal from '../../_components/organisms/CohortDetailsModal';
import summaryPageConstants from '../../core-utils/messages/summaryPageConstants';

const useStyles = makeStyles()({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '1276px',
    padding: '40px 0px 66px 63px',
  },
  contentContainer: {
    marginTop: '1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  dateSelection: {
    flexDirection: 'column',
    gap: '1.5rem',
  },
});

const FinancialForensics = observer(() => {
  const { classes } = useStyles();
  const messages = financialForensicsConstants;
  const cohortMessages = summaryPageConstants.SUMMARY_PAGE;

  const employerGroupStore = useStores().employerGroupStore;
  const loginStore = useStores().loginPageStore;
  const cohortDetailsStore = useStores().cohortDetailsStore;
  const summaryCardsStore = useStores().summaryCardsStore;
  const loginPageStore = useStores().loginPageStore;

  const egNid = employerGroupStore.employerGroupResponseData.eg_nid[0];
  const email = loginStore?.email;
  const userId = loginStore?.userId;

  const abortController = new AbortController();
  const { snackbarState, handleCloseSnackBar, openSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { lastMessage } = useWebSocket(userId);

  const [avaiableDates, setAvaiableDates] = useState<DateType[]>([]);
  const [selectedDates, setSelectedDates] = useState<DateType>({
    startDate: '',
    endDate: '',
  });
  const [inputModalDates, setInputModalDates] = useState<DateType>({
    startDate: '',
    endDate: '',
  });
  const [openDateSelectionModal, setOpenDateSelectionModal] = useState<boolean>(
    false,
  );
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [employeeCount, setEmployeeCount] = useState<EmployeeCount>(
    getEmptyEmployeeCount(),
  );
  const [fixedCost, setFixedCost] = useState<FixedCost>(getEmptyFixedCost());
  const [variableCost, setVariableCost] = useState<VariableCost>(
    getEmptyVariableCost(),
  );
  const [documents, setDocuments] = useState<Document[]>([]);
  const [sourceOfDataOptions, setSourceOfDataOptions] = useState<string[]>([]);
  const [
    sourceOfDataOptionsEmployees,
    setSourceOfDataOptionsEmployees,
  ] = useState<string[]>([]);
  const [
    openFeeCalculationModal,
    setOpenFeeCalculationModal,
  ] = useState<FeeCalculationModalType>(getEmptyFeeCalculationModalState());
  const [
    openReimbursementModal,
    setOpenReimbursementModal,
  ] = useState<ReimbursementModalType>(getEmptyReimbursementModalState());
  const [employeeCountModalOpen, setEmployeeCountModalOpen] = useState<boolean>(
    false,
  );
  const [openVendorModal, setOpenVendorModal] = useState<VendorModalType>(
    getEmptyVendorModalState(),
  );

  const [openStoplossModal, setOpenStoplossModal] = useState<VendorModalType>(
    getEmptyVendorModalState(),
  );
  const [
    openOtherClaimLineModal,
    setOpenOtherClaimLineModal,
  ] = useState<OtherClaimsModalType>(getEmptyOtherClaimsModalState());

  const [
    employeeCountModalDataProps,
    setEmployeeCountModalDataProps,
  ] = useState<EmployeeCountModalProps>(emptyEmployeeCountModalData());
  const [
    selectedEmployeeCountType,
    setSelectedEmployeeCountType,
  ] = useState<FormatType>('count');

  //Build Scenario Modal States
  const [isOpen, setIsOpen] = useState(false);
  const [scenarioInfo, setScenarioInfo] = useState<{
    name: string;
    notes?: string;
  }>({
    name: '',
  });
  //Reconciliation Modal States
  const [
    openReconciliationModal,
    setOpenReconciliationModal,
  ] = useState<boolean>(false);

  const [
    dataForPropsFeeCalculation,
    setdataForPropsFeeCalculation,
  ] = useState<FixedCostFeeCalculation>(emptyFixedCostFeeCalculation());
  const [
    dataForPropsFinancialAdjustments,
    setdataForPropsFinancialAdjustments,
  ] = useState<VendorEntry>(emptyVendorEntry());
  const [
    dataForPropsVariableFees,
    setdataForPropsVariableFees,
  ] = useState<VendorEntry>(emptyVendorEntry());

  const [dataForPropsVendor, setDataForPropsVendor] = useState<Vendor>(
    emptyVendor(),
  );
  const [
    dataForPropsStopLoss,
    setDataForPropsStopLoss,
  ] = useState<StopLossVendor>(emptyStoplossVendor());

  const [fixedCostTableLoading, setFixedCostTableLoading] = useState<boolean>(
    false,
  );
  const [variableCostTableLoading, setVariableCostTableLoading] = useState(
    false,
  );
  const [
    isAvailableDatesLoading,
    setIsAvailableDatesLoading,
  ] = useState<boolean>(true);
  const [reconciliations, setReconciliations] = useState<Reconcilation[]>([]);
  const [documentModalOpen, setDocumentModalOpen] = useState<boolean>(false);
  const [documentToOpen, setDocumentToOpen] = useState<DocumentDetailsForModal>(
    emptyDocumentDetailsForModal(),
  );
  const [openCohortDetailsModal, setOpenCohortDetailsModal] = useState(false);

  const handleScenarioClose = () => {
    setIsOpen(false);
    setScenarioInfo({
      name: '',
    });
  };

  const { prevStartDate, prevEndDate } = getPreviousYearDates(
    selectedDates.startDate,
    selectedDates.endDate,
  );

  const handleAddScenarioOpen = () => {
    setIsOpen(true);
  };

  const handleSaveScenario = async () => {
    const savedScenario = await addScenarios(
      egNid,
      scenarioInfo,
      email,
      selectedDates.startDate,
      selectedDates.endDate,
      0,
      0,
      openSnackbar,
    );

    const defaultFixedCost = resetFeesToZero(fixedCost);
    const defaultVariableCost = resetVariableCostValuesToZero(variableCost);

    if (savedScenario) {
      await saveBuildScenario(
        egNid,
        savedScenario?._id,
        defaultFixedCost,
        defaultVariableCost,
        openSnackbar,
      );
      navigate(SCENARIO_WORKSPACE);
      handleScenarioClose();
    }
  };

  const handleCohortDetailsClose = () => {
    setOpenCohortDetailsModal(false);
  };

  //Reconciliation functions
  const handleAddReconciliationOpen = () => {
    setOpenReconciliationModal(true);
  };

  const handleAddReconciliationClose = () => {
    setOpenReconciliationModal(false);
  };

  const handleSaveReconciliation = async (
    reconciliationInfo: ReconcilationInfo,
  ) => {
    const savedReconciliation = await addReconciliation(
      egNid,
      reconciliationInfo,
      email,
      selectedDates.startDate,
      selectedDates.endDate,
      0,
      0,
      openSnackbar,
    );

    if (savedReconciliation) {
      await addBuildReconciliation(
        egNid,
        savedReconciliation?._id,
        selectedDates.startDate,
        selectedDates.endDate,
        openSnackbar,
      );

      navigate(RECONCILIATION_WORKSPACE);
      handleAddReconciliationClose();
    }
  };
  const handleOpenReconciliation = (reconciliationId: string) => {
    navigate(RECONCILIATION_WORKSPACE, {
      state: {
        id: reconciliationId,
      },
    });
  };

  const handleCloseDateSelectionModal = () => {
    setInputModalDates({ startDate: '', endDate: '' });
    setOpenDateSelectionModal(false);
  };
  const handleDateSelectionModalSubmit = () => {
    addPlanDates();
    setInputModalDates({ startDate: '', endDate: '' });
    setOpenDateSelectionModal(false);
  };

  const handleSelectedTabIndex = (index: number) => {
    setSelectedTabIndex(index);
  };

  const handleFeeClick = (value: any, row: any, vendorID: any, type: any) => {
    setdataForPropsFeeCalculation(row.feeCalculation);
    setOpenFeeCalculationModal({
      open: true,
      unitOfFees: row.unitOfFees,
      actionType: 'ADD',
      selectedVendorID: vendorID,
      selectedServiceID: row.serviceID,
      type,
    });
  };
  const handleFeeUpdate = async (
    updatedCalculation: FixedCostFeeCalculation,
    serviceID: string,
    vendorID: string,
    type: string,
  ) => {
    let finalUpdatedFee = 0;

    const computeFee = (unit: UnitType, baseValue: number) => {
      if (updatedCalculation.option === 'Enter Total Fee') {
        return calculateSum(updatedCalculation.details);
      }

      if (updatedCalculation.option === 'Enter Breakdown') {
        const calculationVariables = getCalculationVariables(
          unit,
          {
            monthCount: updatedCalculation.detailsType === 'Annually' ? 12 : 1,
            yearCount: 1,
          },
          updatedCalculation.details,
        );

        return calculateFee(unit, baseValue, calculationVariables);
      }

      return 0;
    };

    const updateServices = (services: Service[]) =>
      services.map((service) => {
        if (service.serviceID !== serviceID) {
          return service;
        }

        const fee = computeFee(
          service.unitOfFees as UnitType,
          parseFloat(service.value),
        );

        finalUpdatedFee = fee;

        return {
          ...service,
          fees: fee,
          feeCalculation: updatedCalculation,
        };
      });

    const updateSubscriptions = (subscriptions: SubscriptionData[]) =>
      subscriptions.map((sub) => {
        if (sub.subscriptionID !== serviceID) {
          return sub;
        }

        const fee = computeFee(
          sub.unit as UnitType,
          Number(sub.premiumAmount || 0),
        );

        finalUpdatedFee = fee;

        return {
          ...sub,
          fees: fee,
          feeCalculation: updatedCalculation,
        };
      });

    const updateCoverage = (coverageArr: StoplossCoverage[]) =>
      coverageArr.map((cov) => ({
        ...cov,
        subscription: updateSubscriptions(cov.subscription),
      }));

    const updateVendors = (vendors: Vendor[]) =>
      vendors.map((vendor) =>
        vendor.vendorID === vendorID
          ? {
              ...vendor,
              services: updateServices(vendor.services),
            }
          : vendor,
      );

    const updateStopLossVendors = (vendors: StopLossVendor[]) =>
      vendors.map((vendor) =>
        vendor.vendorID === vendorID
          ? {
              ...vendor,
              coverage: updateCoverage(vendor.coverage),
            }
          : vendor,
      );

    setFixedCost((prev) => {
      if (type === 'FEES') {
        return {
          ...prev,
          planContribution: {
            ...prev.planContribution,
            fees: updateVendors(prev.planContribution.fees),
          },
        };
      }

      if (type === 'STOPLOSS') {
        return {
          ...prev,
          planContribution: {
            ...prev.planContribution,
            stoploss: updateStopLossVendors(prev.planContribution.stoploss),
          },
        };
      }

      if (type === 'CREDITS') {
        return {
          ...prev,
          planContribution: {
            ...prev.planContribution,
            credits: updateVendors(prev.planContribution.credits),
          },
        };
      }

      if (type === 'MEMBER') {
        return {
          ...prev,
          memberContribution: updateVendors(prev.memberContribution),
        };
      }

      return prev;
    });

    if (type === 'STOPLOSS') {
      await updateStopLossVendorFeeCalculation(
        vendorID,
        serviceID,
        updatedCalculation,
        finalUpdatedFee,
      );
    } else {
      await updateFeeCalculationVendor(
        type,
        vendorID,
        serviceID,
        updatedCalculation,
        finalUpdatedFee,
      );
    }
  };

  const handleOpenVariableCostEditModal = (rowType: RowType, row: any) => {
    if (rowType === 'primary') {
      setdataForPropsVariableFees(row);
      setOpenOtherClaimLineModal({
        open: true,
        type: 'FEES',
        actionType: 'EDIT',
        selectedVendorID: row.vendorID,
      });
    } else if (rowType === 'secondary') {
      setdataForPropsFinancialAdjustments(row);
      setOpenReimbursementModal({
        open: true,
        type: 'REBATES',
        actionType: 'EDIT',
        selectedVendorID: row.vendorID,
      });
    } else if (rowType === 'member') {
      setdataForPropsVariableFees(row);
      setOpenOtherClaimLineModal({
        open: true,
        type: 'MEMBER',
        actionType: 'EDIT',
        selectedVendorID: row.vendorID,
      });
    }
  };

  const handleEditVendorModal = useCallback(
    (value: Vendor, row: any, rowType: any) => {
      const type = getRowTypeFixedCost(rowType);
      if (!type) {
        throw new Error(`Invalid row type: ${rowType}`);
      }

      if (['FEES', 'CREDITS', 'MEMBER'].includes(type)) {
        setDataForPropsVendor({
          vendorID: value.vendorID,
          nameOfVendor: value.nameOfVendor,
          services: value.services,
        });
        setOpenVendorModal({
          open: true,
          type,
          actionType: 'EDIT',
        });
      } else {
        const stopLossVendor = fixedCost.planContribution.stoploss.find(
          (item) => item.vendorID === value.vendorID,
        );

        if (stopLossVendor) {
          setDataForPropsStopLoss(stopLossVendor);
          setOpenStoplossModal({ open: true, type, actionType: 'EDIT' });
        }
      }
    },
    [fixedCost],
  );

  const fixedCostColumns = useMemo(
    () => getFixedCostColumns(handleFeeClick, handleEditVendorModal),
    [handleFeeClick, handleEditVendorModal],
  );

  const variableCostColumns = useMemo(
    () => getVariableCostColumns(handleOpenVariableCostEditModal),
    [handleOpenVariableCostEditModal],
  );

  //Employee Count Functions
  const handleAddEmployeeDetails = async (employeeCountType: FormatType) => {
    const dataProps = formatEmployeeCountModalData(
      employeeCountType,
      employeeCount,
    );

    setEmployeeCountModalDataProps(dataProps);
    setSelectedEmployeeCountType(employeeCountType);
  };

  const handleSubmitEmployeeDetails = async (data: any) => {
    try {
      setLoading(true);

      const updatedData = formatUpdatedEmployeeCount(
        selectedEmployeeCountType,
        data,
      );

      await axios.post(
        properties.aiqBaseUrl +
          properties.financialForensicsBaseURL +
          properties.updateEmployeeCount,
        {
          eg_nid: employerGroupStore.employerGroupResponseData.eg_nid,
          startDate: selectedDates.startDate,
          endDate: selectedDates.endDate,
          employeeCountData: { ...employeeCount, ...updatedData },
        },
        { signal: abortController.signal },
      );

      const response = await getFinancialForensicsData();
      setEmployeeCount({ ...employeeCount, ...updatedData });
      setFixedCost(response.data.data.fixedCost);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const handleDocumentToOpen = async (fileName: string, rawURL: string) => {
    const url = await createBlobUrl(rawURL);
    setDocumentToOpen({ title: fileName, url });
    setDocumentModalOpen(true);
  };
  const handleFileUpload = async (files: File[]) => {
    try {
      openSnackbar('Uploading Files', 'info', 3000);
      const response = await uploadFiscalControlFiles(
        egNid,
        selectedDates.startDate,
        selectedDates.endDate,
        userId,
        files,
      );
      const newDocs = response.data.data;
      setDocuments((prev) => [...prev, ...newDocs]);
      openSnackbar('Files Uploaded Successfully', 'success', 3000);
    } catch (error) {
      openSnackbar('Error Uploading Files', 'error', 3000);
    }
  };

  const handleFileDelete = async (fileId: string) => {
    try {
      await deleteFiscalControlFile(
        egNid,
        selectedDates.startDate,
        selectedDates.endDate,
        fileId,
      );
      setDocuments((prev) => prev.filter((doc) => doc._id !== fileId));
      openSnackbar('File Deleted Successfully', 'success', 3000);
    } catch (error) {
      openSnackbar('Error Deleting File', 'error', 3000);
    }
  };
  const handleCloseStopLossModal = () => {
    setOpenStoplossModal(getEmptyVendorModalState());
    setDataForPropsStopLoss(
      emptyStoplossVendor(selectedDates.startDate, selectedDates.endDate),
    );
  };

  const {
    isModalOpen,
    uploadedFiles,
    openModal,
    closeModal,
    handleSubmit,
    setUploadedFiles,
  } = useDocumentUpload<string>({
    onUpload: handleFileUpload,
    onError: () => openSnackbar('Error Uploading files', 'error', 2000),
  });

  //API calls
  const getFinancialForensicsData = async () => {
    return await axios.post(
      properties.aiqBaseUrl + properties.financialForensicsBaseURL,
      {
        eg_nid: employerGroupStore.employerGroupResponseData.eg_nid,
        startDate: selectedDates.startDate,
        endDate: selectedDates.endDate,
        max_claim_date:
          employerGroupStore.employerGroupResponseData.max_claim_date,
        isMainPage: true,
      },
      { signal: abortController.signal },
    );
  };
  const addVendor = async (data: any) => {
    try {
      setFixedCostTableLoading(true);
      await addVendorAPI(
        egNid,
        selectedDates.startDate,
        selectedDates.endDate,
        openVendorModal.type,
        data,
      );
      const response = await getFinancialForensicsData();
      setFixedCost(response.data.data.fixedCost);
      setFixedCostTableLoading(false);
      openSnackbar(
        financialForensicsConstants.SUCCESS.ADD_VENDOR,
        'success',
        2000,
      );
    } catch (error) {
      setFixedCostTableLoading(false);
      openSnackbar(financialForensicsConstants.ERROR.ADD_VENDOR, 'error', 2000);
    }
  };
  const updateVendor = async (data: any) => {
    try {
      setFixedCostTableLoading(true);
      await updateVendorAPI(
        egNid,
        selectedDates.startDate,
        selectedDates.endDate,
        openVendorModal.type,
        data,
      );
      const response = await getFinancialForensicsData();
      setFixedCost(response.data.data.fixedCost);
      setFixedCostTableLoading(false);
      openSnackbar(
        financialForensicsConstants.SUCCESS.UPDATE_VENDOR,
        'success',
        2000,
      );
    } catch (error) {
      setFixedCostTableLoading(false);
      openSnackbar(
        financialForensicsConstants.ERROR.UPDATE_VENDOR,
        'error',
        2000,
      );
    }
  };
  const deleteVendor = async (vendorID: string) => {
    try {
      setFixedCostTableLoading(true);
      await deleteVendorAPI(
        egNid,
        selectedDates.startDate,
        selectedDates.endDate,
        openVendorModal.type,
        vendorID,
      );
      const response = await getFinancialForensicsData();
      setFixedCost(response.data.data.fixedCost);
      setFixedCostTableLoading(false);
      openSnackbar(
        financialForensicsConstants.SUCCESS.DELETE_VENDOR,
        'success',
        2000,
      );
    } catch (error) {
      setFixedCostTableLoading(false);
      openSnackbar(
        financialForensicsConstants.ERROR.DELETE_VENDOR,
        'error',
        2000,
      );
    }
  };
  const updateFeeCalculationVendor = async (
    type: string,
    vendorID: string,
    serviceID: string,
    feeCalculation: FixedCostFeeCalculation,
    updatedFee: number,
  ) => {
    try {
      setFixedCostTableLoading(true);
      await updateFeeCalculationVendorAPI(
        egNid,
        selectedDates.startDate,
        selectedDates.endDate,
        type,
        vendorID,
        serviceID,
        feeCalculation,
        updatedFee,
      );
      setFixedCostTableLoading(false);
      openSnackbar(
        financialForensicsConstants.SUCCESS.UPDATE_FEE_CALCULATION,
        'success',
        2000,
      );
    } catch (error) {
      setFixedCostTableLoading(false);
      openSnackbar(
        financialForensicsConstants.ERROR.UPDATE_FEE_CALCULATION,
        'error',
        2000,
      );
    }
  };
  const addClaims = async (data: any) => {
    try {
      setVariableCostTableLoading(true);
      await addClaimsAPI(
        egNid,
        selectedDates.startDate,
        selectedDates.endDate,
        openOtherClaimLineModal.type,
        data,
      );

      const response = await getFinancialForensicsData();
      setVariableCost(response.data.data.variableCost);
      setVariableCostTableLoading(false);
      openSnackbar(
        financialForensicsConstants.SUCCESS.ADD_CLAIMS,
        'success',
        2000,
      );
    } catch (error) {
      setVariableCostTableLoading(false);
      openSnackbar(financialForensicsConstants.ERROR.ADD_CLAIMS, 'error', 2000);
    }
  };
  const updateClaims = async (data: any, vendorID: string) => {
    try {
      setVariableCostTableLoading(true);
      await updateClaimsAPI(
        egNid,
        selectedDates.startDate,
        selectedDates.endDate,
        openOtherClaimLineModal.type,
        data,
        vendorID,
      );

      const response = await getFinancialForensicsData();
      setVariableCost(response.data.data.variableCost);
      setVariableCostTableLoading(false);
      openSnackbar(
        financialForensicsConstants.SUCCESS.UPDATE_CLAIMS,
        'success',
        2000,
      );
    } catch (error) {
      setVariableCostTableLoading(false);
      openSnackbar(
        financialForensicsConstants.ERROR.UPDATE_CLAIMS,
        'error',
        2000,
      );
    }
  };
  const deleteClaims = async (vendorID: string) => {
    try {
      setVariableCostTableLoading(true);
      await deleteClaimsAPI(
        egNid,
        selectedDates.startDate,
        selectedDates.endDate,
        openOtherClaimLineModal.type,
        vendorID,
      );
      const response = await getFinancialForensicsData();
      setVariableCost(response.data.data.variableCost);
      setVariableCostTableLoading(false);
      openSnackbar(
        financialForensicsConstants.SUCCESS.DELETE_CLAIMS,
        'success',
        2000,
      );
    } catch (error) {
      setVariableCostTableLoading(false);
      openSnackbar(
        financialForensicsConstants.ERROR.DELETE_CLAIMS,
        'error',
        2000,
      );
    }
  };
  const addRebates = async (data: any) => {
    try {
      setVariableCostTableLoading(true);
      await addRebatesAPI(
        egNid,
        selectedDates.startDate,
        selectedDates.endDate,
        data,
      );

      const response = await getFinancialForensicsData();
      setVariableCost(response.data.data.variableCost);
      setVariableCostTableLoading(false);
      openSnackbar(
        financialForensicsConstants.SUCCESS.ADD_REBATES,
        'success',
        2000,
      );
    } catch (error) {
      setVariableCostTableLoading(false);
      openSnackbar(
        financialForensicsConstants.ERROR.ADD_REBATES,
        'error',
        2000,
      );
    }
  };
  const updateRebates = async (data: any, vendorID: string) => {
    try {
      setVariableCostTableLoading(true);
      await updateRebatesAPI(
        egNid,
        selectedDates.startDate,
        selectedDates.endDate,
        data,
        vendorID,
      );

      const response = await getFinancialForensicsData();
      setVariableCost(response.data.data.variableCost);
      setVariableCostTableLoading(false);
      openSnackbar(
        financialForensicsConstants.SUCCESS.UPDATE_REBATES,
        'success',
        2000,
      );
    } catch (error) {
      setVariableCostTableLoading(false);
      openSnackbar(
        financialForensicsConstants.ERROR.UPDATE_REBATES,
        'error',
        2000,
      );
    }
  };
  const deleteRebates = async (vendorID: string) => {
    try {
      setVariableCostTableLoading(true);
      await deleteRebatesAPI(
        egNid,
        selectedDates.startDate,
        selectedDates.endDate,
        vendorID,
      );
      const response = await getFinancialForensicsData();
      setVariableCost(response.data.data.variableCost);
      setVariableCostTableLoading(false);
      openSnackbar(
        financialForensicsConstants.SUCCESS.DELETE_CLAIMS,
        'success',
        2000,
      );
    } catch (error) {
      setVariableCostTableLoading(false);
      openSnackbar(
        financialForensicsConstants.ERROR.DELETE_CLAIMS,
        'error',
        2000,
      );
    }
  };
  const getFieldNamesForSourceOfData = async () => {
    return await axios.post(
      properties.aiqBaseUrl +
        properties.dynamicFieldsBaseUrl +
        properties.getDynamicFields,
      {
        field: ['source_of_data', 'source_of_data_employees'],
      },
    );
  };
  const updateFieldNamesForSourceOfData = async (
    value: string,
    field: string,
  ) => {
    if (field === 'source_of_data') {
      setSourceOfDataOptions((prevOptions) => {
        if (prevOptions.includes(value)) {
          return prevOptions;
        }
        return [...prevOptions, value];
      });
    } else if (field === 'source_of_data_employees') {
      setSourceOfDataOptionsEmployees((prevOptions) => {
        if (prevOptions.includes(value)) {
          return prevOptions;
        }
        return [...prevOptions, value];
      });
    }

    try {
      await axios.post(
        properties.aiqBaseUrl +
          properties.dynamicFieldsBaseUrl +
          properties.addDynamicFields,
        {
          field,
          value,
        },
      );
    } catch (error) {
      openSnackbar('Error Updating Source of Data', 'error', 2000);
    }
  };
  const getAvailableDates = async () => {
    try {
      setIsAvailableDatesLoading(true);
      const response = await getAvailableDatesAPI(
        egNid,
        abortController.signal,
      );
      setAvaiableDates(response.data.data);
      setIsAvailableDatesLoading(false);
    } catch (error) {
      openSnackbar('Error Fetching Plan Dates', 'error', 2000);
      setIsAvailableDatesLoading(false);
    }
  };
  const addPlanDates = async () => {
    try {
      setLoading(true);
      await addPlanDatesAPI(
        egNid,
        inputModalDates.startDate,
        inputModalDates.endDate,
      );
      getAvailableDates();
      openSnackbar(
        financialForensicsConstants.SUCCESS.ADD_PLAN_DATES,
        'success',
        2000,
      );
    } catch (error) {
      const axiosError = error as AxiosError<{ error: string }>;

      if (axiosError.response?.data?.error) {
        openSnackbar(axiosError.response.data.error, 'error', 2000);
      } else {
        openSnackbar(
          financialForensicsConstants.ERROR.ADD_PLAN_DATES,
          'error',
          2000,
        );
      }
    } finally {
      setLoading(false);
    }
  };
  const addStopLossVendor = async (data: StopLossVendor) => {
    try {
      setFixedCostTableLoading(true);
      await addStopLossVendorAPI(
        egNid,
        selectedDates.startDate,
        selectedDates.endDate,
        data,
      );
      const response = await getFinancialForensicsData();
      setFixedCost(response.data.data.fixedCost);
      setFixedCostTableLoading(false);

      openSnackbar(
        financialForensicsConstants.SUCCESS.ADD_VENDOR,
        'success',
        2000,
      );
    } catch (error) {
      setFixedCostTableLoading(false);
      openSnackbar(financialForensicsConstants.ERROR.ADD_VENDOR, 'error', 2000);
    }
  };
  const updateStopLossVendor = async (data: any) => {
    try {
      setFixedCostTableLoading(true);
      await updateStoplossVendorAPI(
        egNid,
        selectedDates.startDate,
        selectedDates.endDate,
        data,
      );
      const response = await getFinancialForensicsData();
      setFixedCost(response.data.data.fixedCost);
      setFixedCostTableLoading(false);
      openSnackbar(
        financialForensicsConstants.SUCCESS.UPDATE_VENDOR,
        'success',
        2000,
      );
    } catch (error) {
      setFixedCostTableLoading(false);
      openSnackbar(
        financialForensicsConstants.ERROR.UPDATE_VENDOR,
        'error',
        2000,
      );
    }
  };
  const deleteStopLossVendor = async (vendorID: string) => {
    try {
      setFixedCostTableLoading(true);
      await deleteVendorAPI(
        egNid,
        selectedDates.startDate,
        selectedDates.endDate,
        openStoplossModal.type,
        vendorID,
      );
      const response = await getFinancialForensicsData();
      setFixedCost(response.data.data.fixedCost);
      setFixedCostTableLoading(false);
      openSnackbar(
        financialForensicsConstants.SUCCESS.DELETE_VENDOR,
        'success',
        2000,
      );
    } catch (error) {
      setFixedCostTableLoading(false);
      openSnackbar(
        financialForensicsConstants.ERROR.DELETE_VENDOR,
        'error',
        2000,
      );
    }
  };
  const updateStopLossVendorFeeCalculation = async (
    vendorID: string,
    subscriptionID: string,
    feeCalculation: FixedCostFeeCalculation,
    updatedFee: number,
  ) => {
    try {
      setFixedCostTableLoading(true);
      await updateFeeCalculationStoplossAPI(
        egNid,
        selectedDates.startDate,
        selectedDates.endDate,
        vendorID,
        subscriptionID,
        feeCalculation,
        updatedFee,
      );
      setFixedCostTableLoading(false);
      openSnackbar(
        financialForensicsConstants.SUCCESS.UPDATE_FEE_CALCULATION,
        'success',
        2000,
      );
    } catch (error) {
      setFixedCostTableLoading(false);
      openSnackbar(
        financialForensicsConstants.ERROR.UPDATE_FEE_CALCULATION,
        'error',
        2000,
      );
    }
  };

  const APICalls = async () => {
    setLoading(true);

    selectedDates.startDate !== '' &&
      selectedDates.endDate !== '' &&
      (await Promise.allSettled([
        getFinancialForensicsData(),
        getFieldNamesForSourceOfData(),
        fetchReconciliations(
          egNid,
          selectedDates.startDate,
          selectedDates.endDate,
        ),
      ]).then((responses) => {
        setLoading(false);
        if (responses[0].status === 'fulfilled') {
          const response = responses[0].value.data.data;
          setEmployeeCount(response.employeeCount);
          setFixedCost(response.fixedCost);
          setVariableCost(response.variableCost);
          setDocuments(response.documents ?? []);
        }
        if (responses[1].status === 'fulfilled') {
          const response = responses[1].value.data.data;
          setSourceOfDataOptions(response.source_of_data);
          setSourceOfDataOptionsEmployees(response.source_of_data_employees);
        }
        if (responses[2].status === 'fulfilled') {
          const response = responses[2].value;
          setReconciliations(formatReconcilation(response?.reconciliations));
        }
      }));
  };

  useEffect(() => {
    APICalls();

    return () => {
      abortController.abort();
    };
  }, [selectedDates.startDate, selectedDates.endDate]);

  useEffect(() => {
    if (!egNid) {
      return;
    }
    getAvailableDates();
  }, [egNid]);

  useEffect(() => {
    if (!lastMessage) {
      return;
    }

    if (lastMessage?.status === 'completed') {
      openSnackbar(
        `Extraction completed for ${lastMessage.fileName}. Please refresh to see the latest data.`,
        'success',
        3000,
      );
    }
  }, [lastMessage]);

  //Resubale Components
  const getTitleTypography = (label: string) => {
    return (
      <Typography
        fontSize="18px"
        lineHeight="100%"
        textColor={patientAccessTheme.palette.text.highemphasis}
        fontType="semiBold"
      >
        {label}
      </Typography>
    );
  };

  const getSubTextTypography = (label: string) => {
    return (
      <Typography
        fontSize="17px"
        lineHeight="100%"
        textColor={patientAccessTheme.palette.text.mediumemphasis}
        fontType="semiBold"
      >
        {label}
      </Typography>
    );
  };
  const getDateSelection = () => {
    return (
      <>
        <Grid className={classes.flex}>
          <CustomDateSelectionDropdown
            availableDates={avaiableDates}
            setSelectedDates={setSelectedDates}
          />
          <Button
            label="Add Plan Year"
            startIcon={<Add fill={patientAccessTheme.palette.primary[500]} />}
            variant="text"
            height="32px"
            width="auto"
            onClick={() => {
              setOpenDateSelectionModal(true);
            }}
          />
        </Grid>
      </>
    );
  };

  const getDateSelectionCard = () => {
    return (
      <Grid className={`${classes.flex} ${classes.dateSelection}`}>
        <Group style={{ height: '100px', width: '160px' }} />
        <Grid
          className={`${classes.flex} ${classes.dateSelection}`}
          style={{ gap: '1rem' }}
        >
          <Typography
            fontSize="16px"
            fontType="semiBold"
            textColor={patientAccessTheme.palette.text.highemphasis}
            lineHeight="24px"
          >
            {messages.DATE_SELECTION_TITLE}
          </Typography>
          <Typography
            fontSize="14px"
            fontType="medium"
            textColor={patientAccessTheme.palette.text.mediumemphasis}
            lineHeight="19px"
          >
            {messages.DATE_SELECTION_SUBTITLE}
          </Typography>
        </Grid>

        {getDateSelection()}
      </Grid>
    );
  };

  return (
    <>
      <Grid container className={classes.root}>
        <Grid>
          <PageTitleAndSubTitle
            title={
              <Grid className={classes.flex}>
                {getTitleTypography(messages.title)}

                {selectedDates.startDate !== '' &&
                  selectedDates.endDate !== '' && (
                    <>
                      {getSubTextTypography('for')}
                      {getDateSelection()}
                    </>
                  )}
              </Grid>
            }
            subTitle=""
            customButton={
              !(selectedDates.startDate === '' && selectedDates.endDate === '')
            }
            customButtonText={['Manage Reconciliation', 'Build Scenario']}
            customButtonVariant={['outlined', 'contained']}
            customButtonClick={[
              handleAddReconciliationOpen,
              handleAddScenarioOpen,
            ]}
            customButtonWidth={['190px', '190px']}
            // showQueryDataButton={
            //   selectedDates.startDate !== '' &&
            //   selectedDates.endDate !== '' &&
            //   checkUserAccess(
            //     UserAccessConstants.COHORT_DETAILS,
            //     loginPageStore.userResponse.role.name,
            //     loginPageStore.userFeatures,
            //   )
            // }
            queryButtonText={
              cohortDetailsStore.cohortDetailsList?.length > 0 &&
              cohortDetailsStore.cohortDetailsList[0].category !== ''
                ? 'Edit Cohort'
                : 'Add Cohort'
            }
            queryDataAction={() => {
              if (
                checkUserAccess(
                  UserAccessConstants.COHORT_DETAILS,
                  loginPageStore.userResponse.role.name,
                  loginPageStore.userFeatures,
                )
              ) {
                setOpenCohortDetailsModal(true);
              }
            }}
          />
        </Grid>

        <Grid>
          {isAvailableDatesLoading ? (
            <Loader />
          ) : !selectedDates.startDate && !selectedDates.endDate ? (
            <CardComponent
              title={''}
              body={getDateSelectionCard()}
              mainGridStyles={{
                width: '600px',
                margin: '5rem auto',
              }}
            />
          ) : loading ? (
            <Loader />
          ) : (
            <>
              <TabSelection
                selectedTabIndex={selectedTabIndex}
                setSelectedTabIndex={handleSelectedTabIndex}
                tabList={messages.tabs}
              />
              {selectedTabIndex === 0 && (
                <Financials
                  fixedCostColumns={fixedCostColumns}
                  variableCostColumns={variableCostColumns}
                  fixedPrimary={fixedCost?.planContribution?.fees}
                  fixedSecondary={fixedCost?.planContribution?.credits}
                  fixedTertiary={
                    transformStoplossToVendors(
                      fixedCost?.planContribution?.stoploss ?? [],
                    ) as Vendor[]
                  }
                  fixedMember={fixedCost?.memberContribution ?? []}
                  variablePrimary={variableCost?.planContribution?.fees}
                  variableSecondary={variableCost?.planContribution?.rebates}
                  variableMember={variableCost?.memberContribution ?? []}
                  fixedCostTableLoading={fixedCostTableLoading}
                  variableCostTableLoading={variableCostTableLoading}
                  setOpenVendorModal={setOpenVendorModal}
                  setOpenReimbursementModal={setOpenReimbursementModal}
                  setOpenOtherClaimLineModal={setOpenOtherClaimLineModal}
                  setOpenStoplossModal={setOpenStoplossModal}
                  handleAddNewDocument={openModal}
                />
              )}
              {selectedTabIndex === 1 && (
                <EmployeeCountTab
                  employeeCountData={employeeCount}
                  setEmployeeCountModalOpen={setEmployeeCountModalOpen}
                  handleAddEmployeeDetails={handleAddEmployeeDetails}
                  isMainPage
                />
              )}
              {selectedTabIndex === 2 && (
                <FiscalControlDocumentsTab
                  rowData={formatDocuments(
                    documents,
                    handleDocumentToOpen,
                    handleFileDelete,
                  )}
                  handleAddNewDocument={openModal}
                  tableTitle={'Fiscal Control Documents'}
                  columns={fiscalControlDocumentsColumns}
                />
              )}
            </>
          )}
        </Grid>
        <AddBuildScenarioModal
          open={isOpen}
          handleModalClose={handleScenarioClose}
          handleConfirm={handleSaveScenario}
          scenarioInfo={scenarioInfo}
          setScenarioInfo={setScenarioInfo}
        />

        {openFeeCalculationModal && (
          <FeeCalculationModal
            open={openFeeCalculationModal}
            setOpen={setOpenFeeCalculationModal}
            onClose={() =>
              setdataForPropsFeeCalculation(emptyFixedCostFeeCalculation())
            }
            handleSubmit={(data, serviceID, vendorID, type) => {
              handleFeeUpdate(data, serviceID, vendorID, type);
            }}
            sourceOfDataOptions={sourceOfDataOptions}
            updateFieldNamesForSourceOfData={updateFieldNamesForSourceOfData}
            handleOpenSnackBar={undefined}
            startDate={selectedDates.startDate}
            endDate={selectedDates.endDate}
            dataFromProps={dataForPropsFeeCalculation}
          />
        )}
        <AddReimbursementModal
          open={openReimbursementModal}
          setOpen={setOpenReimbursementModal}
          onClose={() =>
            setdataForPropsFinancialAdjustments(emptyVendorEntry())
          }
          handleSubmit={(data, vendorID) => {
            openReimbursementModal.actionType === 'ADD'
              ? addRebates(data)
              : updateRebates(data, vendorID ?? '');
          }}
          handleOpenSnackBar={() => {}}
          startDate={prevStartDate}
          endDate={prevEndDate}
          dataFromProps={dataForPropsFinancialAdjustments}
          vendorOptions={['HM Life Insurance']}
          typeOptions={['Ogther']}
          handleDelete={deleteRebates}
        />
        {employeeCountModalOpen && (
          <AddEmployeeCountModal
            open={employeeCountModalOpen}
            setOpen={setEmployeeCountModalOpen}
            handleSubmit={handleSubmitEmployeeDetails}
            handleOpenSnackBar={() => {}}
            startDate={prevStartDate}
            endDate={prevEndDate}
            sourceOfDataOptions={sourceOfDataOptionsEmployees}
            updateFieldNamesForSourceOfData={updateFieldNamesForSourceOfData}
            dataFromProps={employeeCountModalDataProps}
            handleCloseModal={() =>
              setEmployeeCountModalDataProps(emptyEmployeeCountModalData())
            }
          />
        )}
        <AddVendorModal
          open={openVendorModal.open}
          setOpen={setOpenVendorModal}
          handleSubmit={
            openVendorModal.actionType === 'ADD' ? addVendor : updateVendor
          }
          handleDelete={deleteVendor}
          handleOpenSnackBar={undefined}
          startDateDefault={selectedDates.startDate}
          endDateDefault={selectedDates.endDate}
          dataFromProps={dataForPropsVendor}
        />
        <AddStoplossModal
          open={openStoplossModal.open}
          handleSubmit={
            openStoplossModal.actionType === 'ADD'
              ? addStopLossVendor
              : updateStopLossVendor
          }
          handleDelete={deleteStopLossVendor}
          handleOpenSnackBar={() => {}}
          startDateDefault={selectedDates.startDate}
          endDateDefault={selectedDates.endDate}
          dataForPropsStopLoss={dataForPropsStopLoss}
          handleCloseM={handleCloseStopLossModal}
        />
        <AddOtherClaimLineModal
          open={openOtherClaimLineModal}
          setOpen={setOpenOtherClaimLineModal}
          onClose={() => {
            setdataForPropsVariableFees(emptyVendorEntry());
          }}
          handleSubmit={(data, vendorID) => {
            openOtherClaimLineModal.actionType === 'ADD'
              ? addClaims(data)
              : updateClaims(data, vendorID ?? '');
          }}
          startDate={prevStartDate}
          endDate={prevEndDate}
          handleDelete={deleteClaims}
          dataFromProps={dataForPropsVariableFees}
        />

        <BasicModal
          open={openDateSelectionModal}
          handleClose={handleCloseDateSelectionModal}
          title={'Select Plan Year'}
          isSaveButton={true}
          saveBtnText="Submit"
          saveBtnDisabled={inputModalDates.startDate === ''}
          saveBtnAction={handleDateSelectionModalSubmit}
        >
          <CustomDateSelection
            inputModalDates={inputModalDates}
            setInputModalDates={setInputModalDates}
          />
        </BasicModal>

        <ReconciliationModal
          open={openReconciliationModal}
          handleClose={handleAddReconciliationClose}
          existingReconciliations={reconciliations}
          handleExisting={handleOpenReconciliation}
          handleNew={handleSaveReconciliation}
        />
        {isModalOpen && (
          <DocumentUploadModal
            open={isModalOpen}
            handleClose={closeModal}
            handleSubmit={handleSubmit}
            uploadedFiles={uploadedFiles}
            setUploadedFiles={setUploadedFiles}
          />
        )}
        {documentModalOpen && (
          <DocumentViewModal
            open={documentModalOpen}
            handleClose={() => {
              setDocumentModalOpen(false);
              setDocumentToOpen(emptyDocumentDetailsForModal());
            }}
            documentDetails={documentToOpen}
          />
        )}
      </Grid>
      <CohortDetailsModal
        open={openCohortDetailsModal}
        isPage={true}
        setOpenCohortDetailsModal={setOpenCohortDetailsModal}
        handleClose={handleCohortDetailsClose}
        title={cohortMessages.COHORT_DETAILS.TITLE}
        subTitle={cohortMessages.COHORT_DETAILS.SUBTITLE}
        totalResults={summaryCardsStore.totalEnrolled?.totalCount}
        // startDate={
        //   aggregationParameter === 'paid' ? paidStartDate : incurredStartDate
        // }
        // endDate={
        //   aggregationParameter === 'paid' ? paidEndDate : incurredEndDate
        // }
        employerGroup={employerGroupStore?.employerGroupResponseData?.eg_nid}
        type="data"
      />
      <Snackbar
        {...snackbarState}
        vertical={'bottom'}
        horizontal={'right'}
        handleClose={handleCloseSnackBar}
      />
    </>
  );
});
export default FinancialForensics;
